var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"d-flex align-items-center justify-content-center"},[_c('div',{staticClass:"quiz"}),_c('QuizLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }